import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { FormattedAmount } from "vino/core";

const OrderBilling = ({ invoice }) => {
	const { subtotalPrice, totalTax, totalPrice, shippingPrice } = invoice;

	return (
		<>
			<TableRow>
				<TableCell colSpan={4}></TableCell>
			</TableRow>
			<TableRow>
				<TableCell colSpan={3}>
					<Typography
						className="font-normal"
						variant="subtitle1"
						color="textSecondary"
					>
						SubTotal
					</Typography>
				</TableCell>
				<TableCell align="right">
					<Typography
						className="font-normal"
						variant="subtitle1"
						color="textSecondary"
					>
						<FormattedAmount value={subtotalPrice} fixedDecimalScale={true} />
					</Typography>
				</TableCell>
			</TableRow>
			<TableRow>
				<TableCell colSpan={3}>
					<Typography
						className="font-normal"
						variant="subtitle1"
						color="textSecondary"
					>
						Tax
					</Typography>
				</TableCell>
				<TableCell align="right">
					<Typography
						className="font-normal"
						variant="subtitle1"
						color="textSecondary"
					>
						<FormattedAmount value={totalTax} fixedDecimalScale={true} />
					</Typography>
				</TableCell>
			</TableRow>
			<TableRow>
				<TableCell colSpan={3}>
					<Typography
						className="font-normal"
						variant="subtitle1"
						color="textSecondary"
					>
						Shipping
					</Typography>
				</TableCell>
				<TableCell align="right">
					<Typography
						className="font-normal"
						variant="subtitle1"
						color="textSecondary"
					>
						<FormattedAmount value={shippingPrice} fixedDecimalScale={true} />
					</Typography>
				</TableCell>
			</TableRow>

			<TableRow>
				<TableCell colSpan={3}>
					<Typography className="font-light" variant="h4" color="textSecondary">
						Total
					</Typography>
				</TableCell>
				<TableCell align="right">
					<Typography className="font-light" variant="h4" color="textSecondary">
						<FormattedAmount value={totalPrice} fixedDecimalScale={true} />
					</Typography>
				</TableCell>
			</TableRow>
		</>
	);
};

export default OrderBilling;
